// Shared Tailwind classes for the filter renderers.
export const INPUT =
    'h-9 w-full rounded-md border border-slate-200 bg-white px-2.5 text-sm text-slate-900 shadow-sm outline-none placeholder:text-slate-400 focus-visible:border-primary-500 focus-visible:ring-2 focus-visible:ring-primary-200';
export const CHOICE_ROW =
    'flex cursor-pointer items-center gap-2.5 rounded-md px-2 py-1.5 text-sm text-slate-700 hover:bg-slate-50 has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-primary-200';
export const CHECK =
    'h-4 w-4 shrink-0 rounded border-slate-300 text-primary-600 focus:ring-0 focus:ring-offset-0 accent-primary-600';
export const RADIO =
    'h-4 w-4 shrink-0 border-slate-300 text-primary-600 focus:ring-0 focus:ring-offset-0 accent-primary-600';
export const SUB_LABEL = 'mb-1 block text-xs font-medium text-slate-600';
